import { FieldRenderProps } from '@progress/kendo-react-form';

import styles from './TextFormField.module.scss';

interface IProps extends FieldRenderProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  customTextGetter: (value: any) => string;
}

export const CustomTextFormField = (fieldRenderProps: IProps) => {
  const { customTextGetter, label, value } = fieldRenderProps;

  return (
    <div className='k-form-field'>
      <label htmlFor='#' className='k-label'>
        {label}
      </label>
      <div className='k-form-field-wrap'>
        <span className={`k-input k-input-md k-rounded-md ${styles.field}`}>{value ? customTextGetter(value) : 'N/A'}</span>
      </div>
    </div>
  );
};
